import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UUID } from "crypto";
import { Observable } from "rxjs";
import { HttpParamsMapper } from "src/app/shared/mappers/http-params.mapper";
import { environment } from "src/environments/environment";

export enum LogCommunicareWebhookStatus {
  PROCESSED = 'Processado',
  PENDING = 'Não processado',
}

export enum LogCommunicareWebhookEvent {
  CREATE_SCHEDULE = 'Agendamento',
  REMOVE_DOCUMENT = 'Remover laudo',
  ADD_DOCUMENT = 'Laudo gerado',
  MISSED_SCHEDULE = 'Marcar falta',
  ATTENDED_SCHEDULE = 'Marcar atendido',
}

export class communicareProfessionalDTO {
  id: number;
  name: string;
  cpf: string;
}

export class ScheduleCommunicareDataDTO {
  communicareScheduleId: string;
  communicareProfessional?: communicareProfessionalDTO;
  communicareTeleconsultationURL?: string;
  communicare_teleconsultation_url?: string;
  teleconsultationLink?: string;
  teleconsultation_url?: string;
  communicarePaymentLink?: string;
  documentUrl?: string;
  documentUrlToDelete?: string;
  scheduleDate?: string;
  attendanceDate?: Date;
}

export class ScheduleCommunicareDTO {
  indicationId: string;
  message: string;
  status?: string;
  data: ScheduleCommunicareDataDTO;
}

export class LogWebhookCommunicareDTO {
  id: UUID;
  indicationId: number;
  communicareScheduleId: number;
  payload: ScheduleCommunicareDTO;
  status: LogCommunicareWebhookStatus;
  event: LogCommunicareWebhookEvent;
  createdAt: number;
  errorReason: string;
}

export class LogWebhookCommunicareOutputDTO {
  items: LogWebhookCommunicareDTO[];
  total: number;
};

export type ListLogWebhookCommunicareFilterInputDTO = {
  data: {
    to: number;
    from: number;
  } | null;
  status: LogCommunicareWebhookStatus | null;
  event: LogCommunicareWebhookEvent | null;
};

@Injectable({ providedIn: 'root' })
export class CommunicareScheduleWebhookService {
    constructor(
        private http: HttpClient,
    ){}

    private url = `${environment.api_v2}/v2/administrative/webhooks-communicare`;

    listAll(filter: ListLogWebhookCommunicareFilterInputDTO, page: number, perPage: number): Observable<LogWebhookCommunicareOutputDTO> {
      const params = HttpParamsMapper.toHttpParams({
        filter: JSON.stringify(filter ?? {}),
        page,
        perPage,
      });
      
      return this.http.get<LogWebhookCommunicareOutputDTO>(this.url, { params });
    }
}

